"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingWithdrawButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const withdrawBalance_json_1 = __importDefault(require("@framework/abis/json/Staking/withdrawBalance.json"));
const hooks_1 = require("../../../../hooks");
const StakingWithdrawButton = (props) => {
    const { balance, className, disabled, variant } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    // transfer the contract when using the button and use the contract id
    const { hasPermission } = (0, hooks_1.useSetButtonPermission)(types_1.AccessControlRoleType.DEFAULT_ADMIN_ROLE, 0);
    const { execute: metaWithdraw } = (0, react_hooks_eth_1.useMetamask)(async (balance) => {
        return writeContractAsync({
            address: balance.account,
            abi: withdrawBalance_json_1.default,
            functionName: "withdrawBalance",
            args: [
                {
                    tokenType: Object.keys(types_1.TokenType).indexOf(balance.token.template.contract.contractType),
                    token: balance.token.template.contract?.address,
                    tokenId: balance.token.tokenId, // must match with staking.penalties[item.token][item.tokenId];
                    amount: 0, // whatever
                },
            ],
        });
    });
    const handleClick = () => {
        return metaWithdraw(balance);
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleClick, icon: icons_material_1.RequestQuote, message: "form.tips.withdrawPenalty", className: className, dataTestId: "StakingBalanceWithdrawButton", disabled: disabled || !hasPermission, variant: variant }));
};
exports.StakingWithdrawButton = StakingWithdrawButton;
//# sourceMappingURL=index.js.map